var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"com-page"},[_c('div',{staticClass:"com-content"},[_c('el-button',{staticClass:"back",attrs:{"plain":""},on:{"click":_vm.pageBack}},[_c('i',{staticClass:"iconfont iconzu131"}),_vm._v("返回 ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }